import { createContext, useContext } from 'react';

export type MarkdownEditorTextareaContextValue = {
  getTextArea: () => HTMLTextAreaElement | null;
};

export const MarkdownEditorTextareaContext = createContext<MarkdownEditorTextareaContextValue | null>(null);

export function useMarkdownEditorTextarea(): MarkdownEditorTextareaContextValue | null {
  return useContext(MarkdownEditorTextareaContext);
}
